import { render, staticRenderFns } from "./ForecastingSaved.vue?vue&type=template&id=1cfdc619"
import script from "./ForecastingSaved.vue?vue&type=script&lang=js"
export * from "./ForecastingSaved.vue?vue&type=script&lang=js"
import style0 from "./ForecastingSaved.vue?vue&type=style&index=0&id=1cfdc619&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports